"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * LocationForm.tsx
 * Author: lnappenfeld
 * Date: 31.08.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const Input_1 = require("./Input");
const react_hook_form_1 = require("react-hook-form");
const Global_1 = require("../functions/Global");
const EPSGCodeSelectList_1 = require("./EPSGCodeSelectList");
const CustomToast_1 = require("./CustomToast");
const SimpleOLMap_1 = require("./SimpleOLMap");
const ReloadPageDialog_1 = require("./ReloadPageDialog");
const spatialservice_npm_1 = require("@dmt/spatialservice_npm");
const LocationForm = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)(['common']);
    const isProjectCenter = (typeof props.isProjectCenter === 'boolean' && props.isProjectCenter) ? props.isProjectCenter : false;
    const locationId = props.location ? props.location.location_id : null;
    const isProjectCenterOld = props.location && props.location.location_zoom ? true : false; // should be project_center if location_zoom is not null
    // Für die Map, falls sich im Formular was ändert, das relevant für die Darstellung ist (name, Koordinaten, ...)
    const [location, setLocation] = (0, react_1.useState)(null);
    // Alle bisher definierten Locations im Project
    const [locations, setLocations] = (0, react_1.useState)(null);
    const [center, setCenter] = (0, react_1.useState)(null);
    const [changedByInput, setChangedByInput] = (0, react_1.useState)(false);
    const [showMap, setShowMap] = (0, react_1.useState)(true);
    const defaultValues = {
        'location_id': props.location ? props.location.location_id : null,
        'location_name': props.location ? props.location.location_name : null,
        'description': props.location ? props.location.location_description : null,
        'epsg_code': props.location ? props.location.epsg_code : 4326,
        'is_visible': props.location ? props.location.is_visible : true,
        'geo_position_x': props.location ? props.location.geo_position_x : null,
        'geo_position_y': props.location ? props.location.geo_position_y : null,
        'geo_position_z': props.location ? props.location.geo_position_z : 0,
        'is_project_center': isProjectCenter // Dialog wurde in ProjectAdvancedSettingsForm.tsx geöffnet
            ? true
            : props.location && props.location.location_zoom // should be project_center if location_zoom is not null
                ? true
                : false,
        'location_zoom': props.location ? props.location.location_zoom : 14.77
    };
    const { control, formState: { errors }, handleSubmit, reset, setValue, getValues, watch, trigger } = (0, react_hook_form_1.useForm)({ defaultValues });
    watch('is_visible');
    watch('geo_position_z');
    watch('is_project_center');
    // watch('epsg_code');
    // For Map update
    watch('location_name');
    watch('geo_position_x');
    watch('geo_position_y');
    watch('location_zoom');
    const getFormErrorMessage = (name) => {
        // @ts-ignore
        return errors[name] && (0, jsx_runtime_1.jsx)("small", Object.assign({ className: "p-error custom" }, { children: errors[name].message }));
    };
    const _setLocations = () => {
        (0, Global_1.getLocations)(props.project.id, props.keycloakfetch, props.settings).then(result => {
            setLocations(result);
        });
    };
    // update Location for Map
    (0, react_1.useEffect)(() => {
        setLocation(getValues());
    }, [
        getValues('location_name'),
        // getValues('geo_position_x'), getValues('geo_position_y'), getValues('geo_position_z'),
    ]);
    (0, react_1.useEffect)(() => {
        if (changedByInput)
            setLocation(getValues());
    }, [
        // getValues('location_name'),
        getValues('geo_position_x'), getValues('geo_position_y'), getValues('geo_position_z'),
    ]);
    (0, react_1.useEffect)(() => {
        console.log('typeof getValues(location_zoom): ', typeof getValues('location_zoom'));
        console.log('getValues(location_zoom): ', getValues('location_zoom'));
        if (center) {
            setCenter({
                'geo_position_x': center.geo_position_x,
                'geo_position_y': center.geo_position_y,
                'location_zoom': getValues('location_zoom')
            });
        }
    }, [getValues('location_zoom')]);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield (0, spatialservice_npm_1.loadEpsgScripts)();
        }))();
        _setLocations();
        if (!props.project.location_id) {
            // If no center is already defined, show Hannover
            const _center = {
                'geo_position_x': 9.7320104,
                'geo_position_y': 52.3758916,
                'epsg_code': 4326,
                'location_zoom': 7
            };
            (() => __awaiter(void 0, void 0, void 0, function* () {
                const center = yield transformCenter(_center);
                setCenter(center);
            }))();
        }
        else {
            (0, Global_1.getLocation)(props.project.id, props.project.location_id, props.keycloakfetch, props.settings).then(result => {
                if (!result['location_zoom'] || result['location_zoom'] === 0) {
                    result['location_zoom'] = 10;
                }
                setValue('location_zoom', parseFloat(result['location_zoom']));
                (() => __awaiter(void 0, void 0, void 0, function* () {
                    const center = yield transformCenter(result);
                    setCenter(center);
                }))();
            });
        }
    }, []);
    const transformCenter = (center) => __awaiter(void 0, void 0, void 0, function* () {
        const _center = center;
        if (center.epsg_code) {
            const coords = [center.geo_position_x, center.geo_position_y, center.geo_position_z];
            const transformedCoords = yield (0, spatialservice_npm_1.transformCoords)(coords, center.epsg_code, 3857);
            // console.log('srcCode: ', center.epsg_code);
            // console.log('desCode: ', 3857);
            // console.log('coordinates: ', coords);
            // console.log('transformedCoords: ', transformedCoords);
            _center.geo_position_x = transformedCoords[0];
            _center.geo_position_y = transformedCoords[1];
            _center.geo_position_z = transformedCoords[2];
        }
        return _center;
    });
    const saveLocation = (data) => {
        // Rename location_name to name
        data['name'] = data['location_name'];
        delete data['location_name'];
        const locationAddProjectId = { 'project_id': props.project.id };
        data = Object.assign(Object.assign({}, locationAddProjectId), data);
        console.log('data: ', data);
        console.log('values: ', getValues());
        if (locationId) {
            console.log(data);
            (0, Global_1.updateLocation)(data, props.keycloakfetch, props.settings).then(result => {
                if (!result.error) {
                    (0, CustomToast_1.showMessageOnSuccess)(t('success'), t('toasts_locationUpdated'));
                    props.onFinished(true);
                    // Die Seite muss neu geladen werden, wenn der Standort als neuer Projektmittelpunkt bestimmt wurde
                    // oder wenn der Standort als Projektmittelpunkt abgewählt wurde,
                    // weil main.get_project_list() neu aufgerufen werden muss
                    if (getValues('is_project_center') !== isProjectCenterOld) {
                        (0, ReloadPageDialog_1.showReloadPageDialog)(t, t('reload_msgProjectCenterChanged'));
                    }
                }
                else {
                    (0, CustomToast_1.showMessageOnError)(t('error'), result.error);
                }
            });
        }
        else {
            (0, Global_1.createLocation)(data, props.keycloakfetch, props.settings).then(result => {
                if (!result.error) {
                    (0, CustomToast_1.showMessageOnSuccess)(t('success'), t('toasts_locationCreated'));
                    props.onFinished(true);
                    // Die Seite muss neu geladen werden, wenn der neu erstellte Standort als Projektmittelpunkt
                    // bestimmt wurde, weil main.get_project_list() neu aufgerufen werden muss.
                    if (getValues('is_project_center')) {
                        (0, ReloadPageDialog_1.showReloadPageDialog)(t, t('reload_msgProjectCenterChanged'));
                    }
                    if (props.saveAndNewClicked) {
                        // Bei 'Speichern und weitere anlegen':
                        // 1. Um die Karte neu zu mounten: verberge diese
                        setShowMap(false);
                        // 2. Leere die Formularfelder
                        reset();
                        // 3. Lade alle bisher angelegten Locations und die aktuelle Location neu
                        (0, Global_1.getLocations)(props.project.id, props.keycloakfetch, props.settings).then(result => {
                            setLocations(result);
                            setLocation(getValues());
                            // 4. Setze den Center und den Zoom in der Karte neu (Ist nach dem reset() verloren gegangen)
                            (0, Global_1.getLocation)(props.project.id, props.project.location_id, props.keycloakfetch, props.settings).then(result => {
                                if (!result['location_zoom'] || result['location_zoom'] === 0) {
                                    result['location_zoom'] = 10;
                                }
                                setValue('location_zoom', parseFloat(result['location_zoom']));
                                (() => __awaiter(void 0, void 0, void 0, function* () {
                                    const center = yield transformCenter(result);
                                    setCenter(center);
                                    // 5. Ganz am Ende: Mounte die Karte neu
                                    setShowMap(true);
                                }))();
                            });
                        });
                    }
                }
                else {
                    (0, CustomToast_1.showMessageOnError)(t('error'), result.error);
                }
            });
        }
    };
    return ((0, jsx_runtime_1.jsx)("form", Object.assign({ id: 'formLocation', onSubmit: handleSubmit(saveLocation), style: { height: '100%' } }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'card grid', style: { height: '100%' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'card col-12 lg:col-4', style: { height: '100%' } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'card' }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'grid' }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'col-6' }, { children: (0, jsx_runtime_1.jsx)(Input_1.Input, { edit: true, label: t('name'), name: 'location_name', validationControl: control, validationErrorMessage: getFormErrorMessage, validationRules: { required: t('name') + ' ' + t('input_required') } }) })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'col-6' }, { children: (0, jsx_runtime_1.jsx)(Input_1.Input, { edit: true, label: t('visible'), name: 'is_visible', type: 'checkbox', validationControl: control, validationErrorMessage: getFormErrorMessage, validationRules: { required: false } }) }))] })), (0, jsx_runtime_1.jsx)(Input_1.Input, { edit: true, label: t('description'), name: 'description', type: 'textarea', validationControl: control, validationErrorMessage: getFormErrorMessage, validationRules: { required: false } })] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'card' }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'grid' }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'col-6' }, { children: [(0, jsx_runtime_1.jsx)(Input_1.Input, { edit: true, label: t('loc_attribs_positionX'), name: 'geo_position_x', type: 'number', maxFractionDigits: 8, value: getValues('geo_position_x'), onChange: (e) => {
                                                    setChangedByInput(true);
                                                    setValue('geo_position_x', e.value);
                                                }, validationControl: control, validationErrorMessage: getFormErrorMessage, validationRules: { required: t('loc_attribs_positionX') + ' ' + t('input_required') } }), (0, jsx_runtime_1.jsx)(Input_1.Input, { edit: true, label: t('loc_attribs_positionY'), name: 'geo_position_y', type: 'number', maxFractionDigits: 8, value: getValues('geo_position_y'), onChange: (e) => {
                                                    setChangedByInput(true);
                                                    setValue('geo_position_y', e.value);
                                                }, validationControl: control, validationErrorMessage: getFormErrorMessage, validationRules: { required: t('loc_attribs_positionY') + ' ' + t('input_required') } }), (0, jsx_runtime_1.jsx)(Input_1.Input, { edit: true, label: t('loc_attribs_positionZ'), name: 'geo_position_z', type: 'number', maxFractionDigits: 8, value: getValues('geo_position_z'), disabled: false, onChange: (e) => {
                                                    setChangedByInput(true);
                                                    setValue('geo_position_z', e.value);
                                                }, validationControl: control, validationErrorMessage: getFormErrorMessage, validationRules: { required: false } })] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'col-6' }, { children: [(0, jsx_runtime_1.jsx)(EPSGCodeSelectList_1.EPSGCodeSelectList, { projectId: props.project.id, name: 'epsg_code', label: t('loc_attribs_epsg'), disabled: false, keycloakfetch: props.keycloakfetch, settings: props.settings, onChange: (e) => {
                                                    const oldEpsgCode = location.epsg_code;
                                                    const epsgCode = e.value;
                                                    setValue('epsg_code', epsgCode);
                                                    (() => __awaiter(void 0, void 0, void 0, function* () {
                                                        // console.log('srcCode: ', oldEpsgCode);
                                                        // console.log('desCode: ', epsgCode);
                                                        // console.log('z_value: ', getValues('geo_position_z'));
                                                        const coordinates = [getValues('geo_position_x'), getValues('geo_position_y'), getValues('geo_position_z')];
                                                        if (oldEpsgCode && epsgCode) {
                                                            const transformedCoords = yield (0, spatialservice_npm_1.transformCoords)(coordinates, oldEpsgCode, epsgCode);
                                                            // console.log('coordinates: ', coordinates);
                                                            // console.log('transformedCoords: ', transformedCoords);
                                                            setChangedByInput(false);
                                                            setValue('geo_position_x', transformedCoords[0]);
                                                            setValue('geo_position_y', transformedCoords[1]);
                                                            setValue('geo_position_z', transformedCoords[2]);
                                                            setLocation(getValues());
                                                        }
                                                    }))();
                                                }, validationControl: control, validationErrorMessage: getFormErrorMessage, validationRules: { required: t('loc_attribs_epsg') + ' ' + t('input_required') } }), (0, jsx_runtime_1.jsx)(Input_1.Input, { edit: true, disabled: isProjectCenter, label: t('loc_attribs_projectCenter'), name: 'is_project_center', type: 'checkbox', validationControl: control, validationErrorMessage: getFormErrorMessage, validationRules: { required: false } }), getValues('is_project_center') && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: 'mt-5' }), (0, jsx_runtime_1.jsx)(Input_1.Input, { edit: true, label: t('loc_attribs_zoom'), name: 'location_zoom', type: 'number', maxFractionDigits: 2, value: getValues('location_zoom'), onChange: (e) => {
                                                            setValue('location_zoom', e.value);
                                                        }, validationControl: control, validationErrorMessage: getFormErrorMessage, validationRules: { required: t('loc_attribs_zoom') + ' ' + t('input_required') } })] })] }))] })) }))] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'card col-12 lg:col-8' }, { children: showMap && center && locations && location &&
                        (0, jsx_runtime_1.jsx)(SimpleOLMap_1.SimpleOLMap, { locations: locations, location: location, center: center, onPositionChange: (coordinates) => {
                                (() => __awaiter(void 0, void 0, void 0, function* () {
                                    const epsgCode = getValues('epsg_code');
                                    if (epsgCode) {
                                        const transformedCoords = yield (0, spatialservice_npm_1.transformCoords)(coordinates, 3857, epsgCode);
                                        // console.log('srcCode: ', 3857);
                                        // console.log('desCode: ', epsgCode);
                                        // console.log('coordinates: ', coordinates);
                                        // console.log('transformedCoords: ', transformedCoords);
                                        setChangedByInput(false);
                                        setValue('geo_position_x', transformedCoords[0]);
                                        setValue('geo_position_y', transformedCoords[1]);
                                        setValue('geo_position_z', transformedCoords[2]);
                                    }
                                }))();
                            }, onZoomChange: (zoom) => {
                                setValue('location_zoom', zoom);
                            } }) }))] })) })));
};
exports.LocationForm = LocationForm;
